export function partAttrMap(info) {
    return Object.entries(info).reduce((result, [partAttr, truthy]) => {
        if (truthy)
            result += ` ${partAttr}`;
        return result;
    }, '');
}
//# sourceMappingURL=directives.js.map